import React from 'react';

const CellDivider = () => (
  <div className="CellDivider" />
);

export default CellDivider;



// WEBPACK FOOTER //
// ./src/components/CellDivider.js